import { createFileRoute } from '@tanstack/react-router'
import i18next from 'i18next'

import { requireAuth } from '@/utils/auth'
import MapSnapshotsPage from '@/components/MapSnapshots/MapSnapshotsPage'
import PageShell from '@/components/Common/PageShell'
import ErrorState from '@/components/Common/ErrorState'

export const Route = createFileRoute('/control-data')({
  beforeLoad: () => requireAuth(),
  component: MapSnapshotsPage,
  errorComponent: ({ error }) => (
    <PageShell title={i18next.t('errorLoadingSchemas', { ns: 'controlData' })}>
      <ErrorState
        title={i18next.t('failedToLoadSchemas', { ns: 'controlData' })}
        message={error.message || i18next.t('unableToLoadSchemas', { ns: 'controlData' })}
      />
    </PageShell>
  ),
})
